import { createRouter, createWebHistory } from 'vue-router';
import Home from '../views/Home.vue';

const routes = [
	{
		path: '/',
		name: 'Home',
		component: Home,
		meta: {
			title: 'Ouderraad Loppem - Shop',
		},
	},
	{
		path: '/tickets',
		name: 'Tickets',
		props: true,
		component: () =>
			import(/* webpackChunkName: "items" */ '../views/Tickets.vue'),
		meta: {
			title: 'Ouderraad Loppem - Tickets',
			authNotRequired: true
		},
	},
	{
		path: '/ticket/:slug',
		name: 'Ticket',
		props: true,
		component: () =>
			import(/* webpackChunkName: "items" */ '../views/Dynamic.vue'),
		meta: {
			title: 'Ouderraad Loppem - Ticket',
			authNotRequired: true
		},
	},
	{
		path: '/ticket',
		redirect: '/tickets'
	},
	{
		path: '/koeken',
		name: 'Koeken',
		props: true,
		component: () =>
			import(/* webpackChunkName: "items" */ '../views/Koeken.vue'),
		meta: {
			title: 'Ouderraad Loppem - Koeken',
			authNotRequired: true
		},
	},
	{
		path: '/shop',
		name: 'Shop',
		props: true,
		component: () =>
			import(/* webpackChunkName: "items" */ '../views/Dynamic.vue'),
		meta: {
			title: 'Ouderraad Loppem - Shop',
			authNotRequired: true
		},
	},
	{
		path: '/shop/:slug',
		name: 'Catalog',
		props: true,
		component: () =>
			import(/* webpackChunkName: "items" */ '../views/Dynamic.vue'),
		meta: {
			title: 'Ouderraad Loppem - Shop',
			authNotRequired: true
		},
	},
	{
		path: '/checkout',
		name: 'Checkout',
		component: () =>
			import(/* webpackChunkName: "checkout" */ '../views/Checkout.vue'),
		meta: {
			title: 'Ouderraad Loppem - Checkout',
		},
	},
	{
		path: '/confirmation/:orderid',
		name: 'Confirmation',
		props: true,
		component: () =>
			import(/* webpackChunkName: "confirmation" */ '../views/Confirmation.vue'),
		meta: {
			title: 'Ouderraad Loppem - Bevestiging',
		},
	},
	{
		path: '/cancel/:orderid',
		name: 'Cancel',
		props: true,
		component: () =>
			import(/* webpackChunkName: "confirmation" */ '../views/Cancel.vue'),
		meta: {
			title: 'Ouderraad Loppem - Geannuleerd',
		},
	},
	{
		path: '/crowdfund',
		name: 'Crowdfund',
		component: () =>
			import(/* webpackChunkName: "donate" */ '../views/Donate.vue'),
		meta: {
			title: 'Ouderraad Loppem - Crowdfund',
		},
	},
	{
		path: '/dashboard',
		name: 'Dashboard',
		component: () =>
			import(/* webpackChunkName: "donate" */ '../views/Dashboard/index.vue'),
		meta: {
			title: 'Ouderraad Loppem - Dashboard',
		},
	}
];

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes,
	scrollBehavior() {
		document.getElementById('app').scrollIntoView();
	},
});

export default router;

// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {

	const nearestWithTitle = to.matched
		.slice()
		.reverse()
		.find((r) => r.meta && r.meta.title);

	// Find the nearest route element with meta tags.
	const nearestWithMeta = to.matched
		.slice()
		.reverse()
		.find((r) => r.meta && r.meta.metaTags);

	const previousNearestWithMeta = from.matched
		.slice()
		.reverse()
		.find((r) => r.meta && r.meta.metaTags);

	// If a route with a title was found, set the document (page) title to that value.
	if (nearestWithTitle) {
		document.title = nearestWithTitle.meta.title;
	} else if (previousNearestWithMeta) {
		document.title = previousNearestWithMeta.meta.title;
	}

	Array.from(
		document.querySelectorAll('[data-vue-router-controlled]')
	).map((el) => el.parentNode.removeChild(el));


	if (!nearestWithMeta) return next();


	nearestWithMeta.meta.metaTags
		.map((tagDef) => {
			const tag = document.createElement('meta');

			Object.keys(tagDef).forEach((key) => {
				tag.setAttribute(key, tagDef[key]);
			});

			// We use this to track which meta tags we create so we don't interfere with other ones.
			tag.setAttribute('data-vue-router-controlled', '');

			return tag;
		})
		// Add the meta tags to the document head.
		.forEach((tag) => document.head.appendChild(tag));

	next();
});
